export default __webpack_public_path__ + "static/media/BAAC.0afdbc80.png";